import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["marketplaceEntity", "href"];
import React from 'react';
import { getLearnMoreLink } from '@nerdwallet/marketplace/selectors/common';
import BaseReviewLink from './base-review-link';
/**
 * Review link component whose link mapping is derived from the provided (raw) Marketplace entity.
 */

var MarketplaceReviewLink = function MarketplaceReviewLink(_ref) {
  var marketplaceEntity = _ref.marketplaceEntity,
      hrefOverride = _ref.href,
      props = _objectWithoutProperties(_ref, _excluded);

  var href = hrefOverride || getLearnMoreLink(marketplaceEntity);
  return /*#__PURE__*/React.createElement(BaseReviewLink, _extends({
    href: href
  }, props));
};

if (process.env.NODE_ENV !== 'production') {
  var PropTypes = require('prop-types'); // eslint-disable-line global-require


  MarketplaceReviewLink.propTypes = _objectSpread({
    /** marketplace entity object */
    marketplaceEntity: PropTypes.object.isRequired
  }, BaseReviewLink.propTypes);
}

export default MarketplaceReviewLink;